module.exports = __webpack_public_path__ + "static/media/human.b5e69ce1.gif";